import materaSignature12_1 from "./materaSignature12 (1).png";
import materaSignature12_2 from "./materaSignature12 (2).png";
import materaSignature12_3 from "./materaSignature12 (3).png";
import materaSignature12_4 from "./materaSignature12 (4).png";
import materaSignature12_5 from "./materaSignature12 (5).png";
import materaSignature12_6 from "./materaSignature12 (6).png";
import materaSignature12_7 from "./materaSignature12 (7).png";
import materaSignature12_8 from "./materaSignature12 (8).png";
import materaSignature12_9 from "./materaSignature12 (9).png";
import materaSignature12_10 from "./materaSignature12 (10).png";
import materaSignature12_11 from "./materaSignature12 (11).png";

const materaSignature12 = [
  materaSignature12_1,
  materaSignature12_2,
  materaSignature12_3,
  materaSignature12_4,
  materaSignature12_5,
  materaSignature12_6,
  materaSignature12_7,
  materaSignature12_8,
  materaSignature12_9,
  materaSignature12_10,
  materaSignature12_11,
];

export default materaSignature12;
